<script lang="ts">
	import { setLocale } from '$i18n/i18n-svelte';
	import { pwaInfo } from 'virtual:pwa-info';
	import { onNavigate } from '$app/navigation';
	import GoogleAnalytics from '$lib/components/GoogleAnalytics.svelte';

	// import { onMount } from 'svelte';

	import Navbar from '$lib/components/Navbar.svelte';

	import '../app.css';

	$: webManifest = pwaInfo ? pwaInfo.webManifest.linkTag : '';



	onNavigate((navigation) => {
		if (!document.startViewTransition) return;
		return new Promise((resolve) => {
			document.startViewTransition(async () => {
				resolve();
				await navigation.complete;
			});
		});
	});

	export let data;
	setLocale(data.locale);
</script>

<GoogleAnalytics />

<svelte:head>
	<!-- eslint-disable-next-line -->
	{@html webManifest}
</svelte:head>

<!-- <Navbar /> -->

<main class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
	<slot />
</main>
